import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import type { Brand } from '@apiTypes';
import { Heading, HStack, Image, VStack } from '@library';
import styles from './BrandSearchMetadata.module.scss';

export const BrandSearchResultsTextHeader = memo(
    ({
        selectedCategoryId,
        categoryName,
    }: {
        categoryName?: string;
        selectedCategoryId?: string;
    }) => {
        return (
            <HStack justify="spaceBetween">
                <Heading h3 bold>
                    {selectedCategoryId && categoryName ? (
                        categoryName
                    ) : (
                        <FormattedMessage id="all categories" />
                    )}
                </Heading>
            </HStack>
        );
    }
);

const BrandSearchMetadata = ({ brand }: { brand?: Brand }) => {
    if (!brand) return <div className={styles.container} />;

    return (
        <div className={styles.container}>
            <HStack gap="small" align="center" wrap>
                <div className={styles.brandImageWrapper}>
                    <Image
                        src={brand.logo}
                        alt={brand.name}
                        size="222px"
                        aspectRatio={0.36}
                    />
                </div>

                <VStack gap="mini">
                    <Heading h3 bold>
                        {brand.name}
                    </Heading>
                </VStack>
            </HStack>
        </div>
    );
};

export default memo(BrandSearchMetadata);
